import { createContext } from 'react';

import { APP_BASE_URL } from '@config/client.config';

const BaseUrlContext = createContext<string>(APP_BASE_URL);

export default BaseUrlContext;
